import styled from 'styled-components';

import { ModalCloseButton as BaseModalClose } from '@components/Modal/next/Modal/utils';
import HorizontalScrollableList, {
  hideScrollbarMixin,
} from '@components/utils/HorizontalScrollableList';
import { UpArrowIcon, DownArrowIcon } from '@assets/icons';

import {
  FeaturesBlock,
  FeatureListContainer,
  FeatureGroupDescription,
  CustomShowMoreText,
} from './styled';

export const TopMenuItem = styled.span`
  cursor: pointer;
  color: ${(p) => p.theme.palette.darkGray};
  font-size: 14px;
  background: ${(p) => p.theme.palette.white};
  padding: 13px 20px;
  white-space: nowrap;
  height: 44px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
export const TopMenu = styled.div<{
  activeItem: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 58px;
  background: ${(p) => p.theme.palette.darkGrey};
  width: 100%;
  padding: 8px 16px;
  margin-top: 20px;
  ${TopMenuItem} {
    flex: 1;
    &[data-item='${(p) => p.activeItem}'] {
      border-bottom: solid 3px ${(p) => p.theme.palette.tomato};
      color: ${(p) => p.theme.palette.coral};
      font-weight: 600;
    }
  }
`;

export const Container = styled.div<{ activeGallery: string }>`
  display: none;
  position: relative;
  ${(p) => p.theme.mediaQueries.GALLERY_SMALL_SCREEN} {
    padding-top: ${(p) => (p.activeGallery ? 0 : 24)}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${(p) => p.theme.palette.lynxWhite};
    height: 100%;

    width: 100%;
    overflow: scroll;
    ${hideScrollbarMixin};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-x: hidden;
  background-color: ${(p) => p.theme.palette.lynxWhite};
  ${FeaturesBlock} {
    padding: 0 0px;
    margin: 0;
    width: 100vw;
    height: unset;
    ${FeatureListContainer} {
      grid-template-columns: 1fr 1fr;
    }
    ${FeatureGroupDescription}, ${CustomShowMoreText} {
      margin-bottom: 20px;
    }
    overflow-y: unset;
  }
`;
export const ModalCloseButton = styled(BaseModalClose)`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const GalleryItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  gap: 15px;
  background: ${(p) => p.theme.palette.white};
  padding-bottom: 15px;
  width: 100%;
`;
export const ImageContainer = styled.div`
  width: 250px;
  height: 143px;
  position: relative;
  border-radius: 8px;
  display: flex;
  gap: 10px;
  img {
    width: 250px;
    height: 100%;
    border-radius: 8px;
  }
  .image-gallery-slide-wrapper {
    border-radius: 0;
  }
`;

export const GalleryTitle = styled.span`
  padding: 15px 0 0px 15px;
  font-size: 18px;
  font-weight: bold;
  color: ${(p) => p.theme.palette.darkGray};
`;

export const HorizontalImageList = styled(HorizontalScrollableList)`
  width: 100vw;
`;

export const LegendTitle = styled.span`
  height: 15px;
  opacity: 0.75;
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.theme.palette.darkGray};
  line-height: normal;
`;

export const LegendItem = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  svg {
    width: 20px;
    height: 20px;
  }
`;
export const Legend = styled.div`
  display: flex;
  width: 100%;
  height: 58px;
  padding: 10px 20px;
  background-color: ${(p) => p.theme.palette.white};
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  position: relative;
  &::after {
    content: '';
    width: 1px;
    height: 38px;
    background-color: ${(p) => p.theme.palette.lightsSilver};
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    position: absolute;
  }
`;

export const FeatureHeader = styled.summary`
  list-style: none;
  padding: 15px 0;
  position: relative;
`;

export const ChevronUp = styled(UpArrowIcon)``;
export const ChevronDown = styled(DownArrowIcon)``;

export const FeatureContainer = styled.details`
  background-color: ${(p) => p.theme.palette.white};
  margin-bottom: 20px;
  padding: 0 15px;
  &:first-of-type {
    margin-top: 20px;
  }
  ${FeatureHeader} {
    ${ChevronUp}, ${ChevronDown} {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 15px;
      top: 0;
      margin: auto;
      bottom: 0;
    }
  }
  & {
    ${ChevronUp} {
      display: none;
    }
    ${ChevronDown} {
      display: block;
    }
  }
  &[open] {
    padding-bottom: 20px;
    ${ChevronDown} {
      display: none;
    }
    ${ChevronUp} {
      display: block;
    }
  }
`;

export const GalleryContainerMobile = styled.div`
  max-height: 100%;
  width: 100%;
  background-color: ${(p) => p.theme.palette.darkGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const RoomFeaturesContainer = styled.div`
  padding: 15px;
`;

export const ModalTitle = styled.span`
  height: 18px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  color: ${(p) => p.theme.palette.darkGrey};
  display: inline-block;
  margin-bottom: 10px;
`;
